
jQuery(document).ready(function () {
    var now = new Date(Date.now());
    var formatted = now.getHours() + ":" + now.getMinutes();
    // 20:10:58
    jQuery('#datetimepicker1').datetimepicker({
        datepicker: false,
        step: 30,
        format: 'H:i',
        minTime: '10:00',
        maxTime: '17:30'
    });

    jQuery('#datetimepicker123').datetimepicker({
        timepicker: false,
        format: 'd.m.Y',
        minDate: new Date(),
        beforeShowDay: function (date) {
            var day = date.getDay();
            return [(day != 0), ''];
        },
        onSelectDate: function (date) {
            jQuery('#datetimepicker1').datetimepicker('reset');
            var day = date.getDay();
            if (day == 5) {
                jQuery('#datetimepicker1').datetimepicker('setOptions', {
                    maxTime: '19:30'
                });
            } else if (day === 6) {
                jQuery('#datetimepicker1').datetimepicker('setOptions', {
                    maxTime: '17:00'
                });
            } else {
                jQuery('#datetimepicker1').datetimepicker('setOptions', {
                    maxTime: '17:30'
                });
            }
        }
    });
});



jQuery(".enqiour_now").click(function () {
    var name = jQuery(this).attr('data-name');
    jQuery('#contactFormproname').val(name);
});

jQuery(".product-share .share-title").click(function () {
    jQuery('.hide-social').slideToggle();
    jQuery(this).find('span').toggleClass('angle-down angle-up');
});



jQuery(document).ready(function () {
    jQuery(document).on("click", ".filter-click", function () {
        jQuery('.filter-nav').not(jQuery(this).closest('.fil-sec').children('.filter-nav')).hide();
        jQuery('.fil-sec').not(jQuery(this).parent('.fil-sec')).removeClass('open-active');
        jQuery('.filter-nav').not(jQuery(this).closest('.fil-sec').children('.filter-nav')).removeClass('open-nav');
        jQuery('.filter-click').removeClass('open-menu');
        jQuery('.filter-click').removeClass('angle-up');
        jQuery('.filter-click').addClass('angle-down');

        jQuery(this).parent('.fil-sec').toggleClass("open-active");
        jQuery(this).closest('.fil-sec').children('.filter-nav').slideToggle();
        jQuery(this).closest('.fil-sec').children('.filter-nav').toggleClass('open-nav');
        jQuery(this).toggleClass('open-menu');
        jQuery(this).toggleClass('angle-down angle-up');
    });
});


jQuery(document).ready(function () {
    jQuery(document).on("click", ".begin_dmond", function () {
        jQuery('.select_error').hide();
        jQuery('.begin').removeClass('active');
        jQuery(this).addClass('active');
        jQuery('.step-gstone').removeClass('active-tab');
        jQuery('.step-dmond').addClass('active-tab');
        jQuery('.step-dmond').show();
        jQuery('.step-gstone').hide();
        jQuery(".step-gstone input[name='contact[Gemstone size]']").prop('checked', false);
        jQuery("input[type='radio']").removeClass('selected');
        jQuery('.img-show.diamond').show();
        jQuery('.img-show.gems').hide();
    });
    jQuery(document).on("click", ".begin_gstone", function () {
        jQuery('.select_error').hide();
        jQuery('.begin').removeClass('active');
        jQuery(this).addClass('active');
        jQuery('.step-dmond').removeClass('active-tab');
        jQuery('.step-gstone').addClass('active-tab');
        jQuery('.step-dmond').hide();
        jQuery('.step-gstone').show();
        jQuery(".step-dmond input[name='contact[Diamond size]']").prop('checked', false);
        jQuery("input[type='radio']").removeClass('selected');
        jQuery('.img-show.diamond').hide();
        jQuery('.img-show.gems').show();
    });
    jQuery(document).on("click", "input[type='radio']", function () {
        jQuery("input[type='radio']").removeClass('selected');
        jQuery(this).addClass("selected");
        jQuery('.cmn-img').hide();
        var valueid = jQuery(this).attr('id');
        jQuery('.' + valueid).show();
    });
    jQuery(document).on("click", ".next_step2", function () {
        if (jQuery('.begin').hasClass('active')) {
            if (jQuery('input[type="radio"]').hasClass('selected')) {
                //jQuery('.step_error').hide();
                jQuery('.select_error').hide();
                jQuery('.step1.steps-cmn').hide();
                jQuery('.step2.steps-cmn').show();
            } else {
                //             jQuery('.step_error.color-black').hide();
                //           jQuery('.step_error').show();
            }
        } else {
            //jQuery('.step_error.color-black').hide();
            jQuery('.select_error').show();
        }
    });
    jQuery(document).on("click", ".next_step3", function () {
        if (jQuery('.step2.steps-cmn input[type="radio"]').hasClass('selected')) {
            //jQuery('.step_error').hide();
            jQuery('.step2.steps-cmn').hide();
            jQuery('.step3.steps-cmn').show();
        } else {
            //jQuery('.step_error.color-black').hide();
            //jQuery('.step_error').show();
        }
    });
    jQuery(document).on("click", ".next_step4", function () {
        if (jQuery('.step3.steps-cmn input[type="radio"]').hasClass('selected')) {
            //jQuery('.step_error').hide();
            jQuery('.step3.steps-cmn').hide();
            jQuery('.step4.steps-cmn').show();
        } else {
            //jQuery('.step_error.color-black').hide();
            //jQuery('.step_error').show();
        }
    });
    jQuery(document).on("click", ".next_step5", function () {
        if (jQuery('.step4.steps-cmn input[type="radio"]').hasClass('selected')) {
            //jQuery('.step_error').hide();
            jQuery('.step4.steps-cmn').hide();
            jQuery('.step5.steps-cmn').show();
        } else {
            //jQuery('.step_error.color-black').hide();
            //jQuery('.step_error').show();
        }
    });
    jQuery(document).on("click", ".prev_step1", function () {
        jQuery('.step2.steps-cmn').hide();
        jQuery('.step1.steps-cmn').show();
    });
    jQuery(document).on("click", ".prev_step2", function () {
        jQuery('.step3.steps-cmn').hide();
        jQuery('.step2.steps-cmn').show();
    });
    jQuery(document).on("click", ".prev_step3", function () {
        jQuery('.step4.steps-cmn').hide();
        jQuery('.step3.steps-cmn').show();
    });
    jQuery(document).on("click", ".prev_step4", function () {
        jQuery('.step5.steps-cmn').hide();
        jQuery('.step4.steps-cmn').show();
    });


});


jQuery("ul.form-list li").click(function () {
    jQuery(this).closest('.left_side').children('.stepping_form_sec').find('.step_error').hide();

});


jQuery('#menu-item-5611bb24-78bd-4be4-9965-8b5030c3908a .item-level-0 .lang1').html('collections');


jQuery(document).ready(function () {
    jQuery('li.menu-item-engagement-wedding .sub-menu-dropdown').find('.vc_column_container.vc_col-sm-3:first').before('<div class="menu-title"><a href="/collections/engagement-rings">Engagement Rings</a></div>');
    jQuery('li.menu-item-engagement-wedding .sub-menu-dropdown').find('.vc_column_container.vc_col-sm-3:last').after('<div class="menu-title"><a href="/collections/wedding-rings">Wedding Rings</a></div>');
    jQuery('li.menu-item-钻戒-婚戒 .sub-menu-dropdown').find('.vc_column_container.vc_col-sm-3:first').before('<div class="menu-title"><a href="/zh-cn/collections/engagement-rings">钻戒</a></div>');
    jQuery('li.menu-item-钻戒-婚戒 .sub-menu-dropdown').find('.vc_column_container.vc_col-sm-3:last').after('<div class="menu-title"><a href="/zh-cn/collections/wedding-rings">婚戒</a></div>');
});


jQuery(document).ready(function () {
    var hash = window.location.hash;
    if (hash == '#begin-diamond') {
        jQuery('.select_error').hide();
        jQuery('.begin').removeClass('active');
        jQuery('.begin_dmond').addClass('active');
        jQuery('.step-gstone').removeClass('active-tab');
        jQuery('.step-dmond').addClass('active-tab');
        jQuery('.step-dmond').show();
        jQuery('.step-gstone').hide();
        jQuery(".step-gstone input[name='contact[Gemstone size]']").prop('checked', false);
        jQuery("input[type='radio']").removeClass('selected');
        jQuery('.img-show.diamond').show();
        jQuery('.img-show.gems').hide();
    }
    if (hash == '#begin-gemstone') {
        jQuery('.select_error').hide();
        jQuery('.select_error').hide();
        jQuery('.begin').removeClass('active');
        jQuery('.begin_gstone').addClass('active');
        jQuery('.step-dmond').removeClass('active-tab');
        jQuery('.step-gstone').addClass('active-tab');
        jQuery('.step-dmond').hide();
        jQuery('.step-gstone').show();
        jQuery(".step-dmond input[name='contact[Diamond size]']").prop('checked', false);
        jQuery("input[type='radio']").removeClass('selected');
        jQuery('.img-show.diamond').hide();
        jQuery('.img-show.gems').show();
    }
});



jQuery(document).ready(function () {
    jQuery(document).on("click", ".filter-nav li", function () {
        jQuery('.no_prod').remove();
        jQuery('.product-grid-item').hide();
        jQuery('.products.elements-grid').prepend('<div class="loadingdata11"><img loading="lazy" src="https://cdn.shopify.com/s/files/1/0536/3086/1474/files/loading.gif?v=1623387975"></div>');
        jQuery(this).closest('.filter-nav').find('li').removeClass('active');
        jQuery(this).addClass('active');
        jQuery(this).closest('.filter-nav').hide();
        var dataid = jQuery(this).attr('data-id');
        var style = jQuery('.stylenav li.active').attr('data-id');
        var cut = jQuery('.cutnav li.active').attr('data-id');
        var material = jQuery('.materialnav li.active').attr('data-id');

        setTimeout(function () {
            if (cut !== undefined) {
                jQuery('.cuttitle').html(cut + ' (Cut)');
                jQuery('.cutselect').html('<span class="cut_close"><i class="fa fa-close"></i>' + cut + ' (cut)</span>');
            }
            if (style !== undefined) {
                jQuery('.styletitle').html(style + ' (style)');
                jQuery('.styleselect').html('<span class="style_close"><i class="fa fa-close"></i>' + style + ' (style)</span>');
            }
            if (material !== undefined) {
                jQuery('.materialtitle').html(material + ' (material)');
                jQuery('.materialselect').html('<span class="material_close"><i class="fa fa-close"></i>' + material + ' (material)</span>');
            }

            if (cut !== undefined && material !== undefined && style !== undefined) {
                jQuery('.loadingdata11').remove();
                jQuery('.M' + material + '.' + cut + '.' + style).show();
                if (jQuery('.M' + material + '.' + cut + '.' + style)[0]) {} else {
                    jQuery('.products.elements-grid').append('<p class="no_prod">There are no products found!!!</p>');
                }
            }

            if (cut == undefined && material !== undefined && style !== undefined) {
                jQuery('.loadingdata11').remove();
                jQuery('.M' + material + '.' + style).show();
                if (jQuery('.M' + material + '.' + style)[0]) {} else {
                    jQuery('.products.elements-grid').append('<p class="no_prod">There are no products found!!!</p>');
                }
            }

            if (cut == undefined && material == undefined && style !== undefined) {
                jQuery('.loadingdata11').remove();
                jQuery('.' + style).show();
                if (jQuery('.' + style)[0]) {} else {
                    jQuery('.products.elements-grid').append('<p class="no_prod">There are no products</p>');
                }
            }

            if (cut !== undefined && material == undefined && style == undefined) {
                jQuery('.loadingdata11').remove();
                jQuery('.' + cut).show();
                if (jQuery('.' + cut)[0]) {} else {
                    jQuery('.products.elements-grid').append('<p class="no_prod">There are no products found!!!</p>');
                }

            }

            if (cut == undefined && material !== undefined && style == undefined) {
                jQuery('.loadingdata11').remove();
                jQuery('.M' + material).show();
                if (jQuery('.M' + material)[0]) {} else {
                    jQuery('.products.elements-grid').append('<p class="no_prod">There are no products found!!!</p>');
                }
            }

            if (cut !== undefined && material !== undefined && style == undefined) {
                jQuery('.loadingdata11').remove();
                jQuery('.M' + material + '.' + cut).show();
                if (jQuery('.M' + material + '.' + cut)[0]) {} else {
                    jQuery('.products.elements-grid').append('<p class="no_prod">There are no products found!!!</p>');
                }
            }

            if (cut !== undefined && material == undefined && style !== undefined) {
                jQuery('.loadingdata11').remove();
                jQuery('.' + cut + '.' + style).show();
                if (jQuery('.' + cut + '.' + style)[0]) {} else {
                    jQuery('.products.elements-grid').append('<p class="no_prod">There are no products found!!!</p>');
                }
            }
        }, 1500);


    });


    jQuery(document).on("click", ".cut_close", function () {
        jQuery('.cutnav li').removeClass('active');
        jQuery('.cuttitle').html('Cut');
        jQuery(this).html('');

        var dataid = jQuery(this).attr('data-id');
        var style = jQuery('.stylenav li.active').attr('data-id');
        var cut = jQuery('.cutnav li.active').attr('data-id');
        var material = jQuery('.materialnav li.active').attr('data-id');


        setTimeout(function () {
            if (cut !== undefined) {
                jQuery('.cuttitle').html(cut + ' (Cut)');
                jQuery('.cutselect').html('<span class="cut_close"><i class="fa fa-close"></i>' + cut + ' (cut)</span>');
            }
            if (style !== undefined) {
                jQuery('.styletitle').html(style + ' (style)');
                jQuery('.styleselect').html('<span class="style_close"><i class="fa fa-close"></i>' + style + ' (style)</span>');
            }
            if (material !== undefined) {
                jQuery('.materialtitle').html(material + ' (material)');
                jQuery('.materialselect').html('<span class="material_close"><i class="fa fa-close"></i>' + material + ' (material)</span>');
            }

            if (cut !== undefined && material !== undefined && style !== undefined) {
                jQuery('.loadingdata11').remove();
                jQuery('.M' + material + '.' + cut + '.' + style).show();
            }

            if (cut == undefined && material !== undefined && style !== undefined) {
                jQuery('.loadingdata11').remove();
                jQuery('.M' + material + '.' + style).show();
            }

            if (cut == undefined && material == undefined && style !== undefined) {
                jQuery('.loadingdata11').remove();
                jQuery('.' + style).show();
            }

            if (cut !== undefined && material == undefined && style == undefined) {
                jQuery('.loadingdata11').remove();
                jQuery('.' + cut).show();

            }

            if (cut == undefined && material !== undefined && style == undefined) {
                jQuery('.loadingdata11').remove();
                jQuery('.M' + material).show();
            }

            if (cut !== undefined && material !== undefined && style == undefined) {
                jQuery('.loadingdata11').remove();
                jQuery('.M' + material + '.' + cut).show();
            }

            if (cut !== undefined && material == undefined && style !== undefined) {
                jQuery('.loadingdata11').remove();
                jQuery('.' + cut + '.' + style).show();
            }
        }, 1500);


    });
    jQuery(document).on("click", ".style_close", function () {
        jQuery('.stylenav li').removeClass('active');
        jQuery('.styletitle').html('Style');

        jQuery(this).html('');

        var dataid = jQuery(this).attr('data-id');
        var style = jQuery('.stylenav li.active').attr('data-id');
        var cut = jQuery('.cutnav li.active').attr('data-id');
        var material = jQuery('.materialnav li.active').attr('data-id');


        setTimeout(function () {
            if (cut !== undefined) {
                jQuery('.cuttitle').html(cut + ' (Cut)');
                jQuery('.cutselect').html('<span class="cut_close"><i class="fa fa-close"></i>' + cut + ' (cut)</span>');
            }
            if (style !== undefined) {
                jQuery('.styletitle').html(style + ' (style)');
                jQuery('.styleselect').html('<span class="style_close"><i class="fa fa-close"></i>' + style + ' (style)</span>');
            }
            if (material !== undefined) {
                jQuery('.materialtitle').html(material + ' (material)');
                jQuery('.materialselect').html('<span class="material_close"><i class="fa fa-close"></i>' + material + ' (material)</span>');
            }

            if (cut !== undefined && material !== undefined && style !== undefined) {
                jQuery('.loadingdata11').remove();
                jQuery('.M' + material + '.' + cut + '.' + style).show();
            }

            if (cut == undefined && material !== undefined && style !== undefined) {
                jQuery('.loadingdata11').remove();
                jQuery('.M' + material + '.' + style).show();
            }

            if (cut == undefined && material == undefined && style !== undefined) {
                jQuery('.loadingdata11').remove();
                jQuery('.' + style).show();
            }

            if (cut !== undefined && material == undefined && style == undefined) {
                jQuery('.loadingdata11').remove();
                jQuery('.' + cut).show();

            }

            if (cut == undefined && material !== undefined && style == undefined) {
                jQuery('.loadingdata11').remove();
                jQuery('.M' + material).show();
            }

            if (cut !== undefined && material !== undefined && style == undefined) {
                jQuery('.loadingdata11').remove();
                jQuery('.M' + material + '.' + cut).show();
            }

            if (cut !== undefined && material == undefined && style !== undefined) {
                jQuery('.loadingdata11').remove();
                jQuery('.' + cut + '.' + style).show();
            }
        }, 1500);

    });
    jQuery(document).on("click", ".material_close", function () {
        jQuery('.materialnav li').removeClass('active');
        jQuery('.materialtitle').html('Material');
        jQuery(this).html('');

        var dataid = jQuery(this).attr('data-id');
        var style = jQuery('.stylenav li.active').attr('data-id');
        var cut = jQuery('.cutnav li.active').attr('data-id');
        var material = jQuery('.materialnav li.active').attr('data-id');


        setTimeout(function () {
            if (cut !== undefined) {
                jQuery('.cuttitle').html(cut + ' (Cut)');
                jQuery('.cutselect').html('<span class="cut_close"><i class="fa fa-close"></i>' + cut + ' (cut)</span>');
            }
            if (style !== undefined) {
                jQuery('.styletitle').html(style + ' (style)');
                jQuery('.styleselect').html('<span class="style_close"><i class="fa fa-close"></i>' + style + ' (style)</span>');
            }
            if (material !== undefined) {
                jQuery('.materialtitle').html(material + ' (material)');
                jQuery('.materialselect').html('<span class="material_close"><i class="fa fa-close"></i>' + material + ' (material)</span>');
            }

            if (cut !== undefined && material !== undefined && style !== undefined) {
                jQuery('.loadingdata11').remove();
                jQuery('.M' + material + '.' + cut + '.' + style).show();
            }

            if (cut == undefined && material !== undefined && style !== undefined) {
                jQuery('.loadingdata11').remove();
                jQuery('.M' + material + '.' + style).show();
            }

            if (cut == undefined && material == undefined && style !== undefined) {
                jQuery('.loadingdata11').remove();
                jQuery('.' + style).show();
            }

            if (cut !== undefined && material == undefined && style == undefined) {
                jQuery('.loadingdata11').remove();
                jQuery('.' + cut).show();

            }

            if (cut == undefined && material !== undefined && style == undefined) {
                jQuery('.loadingdata11').remove();
                jQuery('.M' + material).show();
            }

            if (cut !== undefined && material !== undefined && style == undefined) {
                jQuery('.loadingdata11').remove();
                jQuery('.M' + material + '.' + cut).show();
            }

            if (cut !== undefined && material == undefined && style !== undefined) {
                jQuery('.loadingdata11').remove();
                jQuery('.' + cut + '.' + style).show();
            }
        }, 1500);

    });
});
